import React from "react";
import { Facet } from "@linkfluence/models/facet";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DatavizHorizontalStackedBarChart } from "@radarly/models/dataviz";
import { SearchFragmentPivot, getTermFromAggs } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import Metric from "@radarly/shared/cards/subtitle/metric";
import Tile from "@radarly/shared/cards/tile";
import HorizontalStackedBarChart from "@radarly/shared/widgets/pivot/horizontal-stacked-bar-chart";
import { useFacets } from "../facets";
import { CardFragmentProps } from "../model";

const RadarlyPivotCardsHorizontalStackedBarChart = ({
  title,
  fragment,
  dataviz,
  project,
  height,
  onClickItem,
  onGenerateCSV,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<
  SearchFragmentPivot,
  DatavizHorizontalStackedBarChart
>) => {
  const pivotField = getTermFromAggs(fragment.request.aggs) as Facet;
  const againstField = getTermFromAggs(
    fragment.request.aggs[pivotField].aggs
  ) as Facet;
  const metric = fragment.request.aggs[pivotField].metrics[0];
  const pivot = useFacets(pivotField, fragment.request.query);
  const against = useFacets(againstField, fragment.request.query);
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <Metric metric={metric} />,
          ]}
        />
      }
      clause={fragment.request.query}
      onGenerateCSV={onGenerateCSV}
      isPNG
    >
      <HorizontalStackedBarChart
        fragment={fragment}
        project={project.id}
        pivot={pivot}
        against={against}
        onClickGauge={onClickItem}
        dataviz={dataviz}
        forceReload={forceReload}
      />
    </Tile>
  );
};

export default RadarlyPivotCardsHorizontalStackedBarChart;
